import { styled } from '@mui/system';

const GlobalClassStyles  = styled('div')(({theme}) => ({
  '.BoxShadow': {
    boxShadow: `0px 1px 8px rgb(${theme.vars.palette.primary.mainChannel} / 0.12)`
  },
  '.center': {
    textAlign: 'center'
  },
  '[tabindex="0"]:focus-visible': {
    outline: 'none'
  },
  height: '100%'
}))

const BoxPanel = styled('div', {target: 'BoxPanel'})(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(2)
}));

const BasePosition = styled(GlobalClassStyles, {target: 'BasePosition'})(() => ({
  display: 'flex',
  flexDirection: "column",
  alignItems: "center",
  position: 'relative',
  zIndex: 1
}))

const BaseWrapper = styled(GlobalClassStyles, {target: 'BaseWrapper'})(() => ({
  display: 'flex',
  flexDirection: "column",
  width: 'min(100%, 800px)',
}))

const Main = styled(GlobalClassStyles,{target: 'Main'})(({theme}) => ({
  background: '#fff',
  position: 'relative',
  borderRadius: theme.spacing(1),
  scrollbarGutter: 'stable',
  padding: theme.spacing(3,4,3,5),
  overflowWrap: 'anywhere',
  [theme.breakpoints.up('sm')]: {
    maxHeight: '450px',
  },
  marginTop: theme.spacing(1),
  overflowY: 'auto',
  "&.previewSmallScreen": {
    borderRadius: '5%',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  "&.successStepActive": {
    background: 'transparent',
    maxHeight: 'fit-content',
    msOverflowStyle: 'none',  /* IE and Edge */
    scrollbarWidth: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    '@media (max-height: 480px)': {
      // padding: theme.spacing(11),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0.4)
    }
  }
}));

const BasisRoot = styled('div',{target: 'BasisRoot'})(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '95%',
}))

const TitleStyle = styled('div', { target: 'TitleStyle' })(({theme}) => ({
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(2)
}));

const ServicesAndServiceTypesRoot = styled(BasisRoot)(({theme}) => ({
  '& .TypographyAndSearch': {
    margin: theme.spacing(0,1,0,1)
  },
  '& .ListRoot': {
    padding: theme.spacing(1),
  },
  '.TextField':{
    marginBottom: theme.spacing(2)
  },
  '& .SeeAllButton': {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1)
  },
  '& .StyledListItemButton': {
    textAlign: 'left'
  }
}));

export {
  BasePosition,
  BaseWrapper,
  Main,
  BoxPanel,
  BasisRoot,
  TitleStyle,
  ServicesAndServiceTypesRoot
}